import type React from 'react'

import { textColorVariants, textVariants } from '@/lib/constants'
import { cn } from '@/lib/styles'

type FontSize = keyof typeof textVariants
type TextColor = keyof typeof textColorVariants
export type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

interface HeadingProps {
	children: React.ReactNode
	className?: string
	fontSize?: FontSize
	textColor?: TextColor
	tag?: HeadingTag
}

const Heading = ({
	children,
	className,
	fontSize = 'displayMedium',
	textColor = 'black',
	tag = 'h3',
}: HeadingProps) => {
	const textStyle = textVariants[fontSize]
	const textColorClassName = textColorVariants[textColor]

	const Tag = tag as HeadingTag

	if (!Tag) {
		return null
	}

	const combinedClassName = cn('w-fit', textStyle, textColorClassName, className)

	return <Tag className={combinedClassName}>{children}</Tag>
}

export default Heading
